// src/super_admin/AddUserForm.js
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

function AddUserForm() {
  const { companyId } = useParams();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("admin"); // o "chef"/"waiter", come preferisci
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      const token = localStorage.getItem("access_token");
      const payload = {
        username,
        email,
        password,
        role,
        company_id: parseInt(companyId, 10),
      };

      // endpoint dedicato? /super_admin/users? O /super_admin/companies/{companyId}/users
      // dipende da come l'hai impostato
      const res = await fetch(`${process.env.REACT_APP_API_URL}/super_admin/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const dataErr = await res.json();
        throw new Error(dataErr.detail || "Errore creazione utente");
      }
      // al termine, naviga indietro
      navigate(`/super_admin/companies/${companyId}`);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <h1>Aggiungi utente alla company {companyId}</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}

      <form onSubmit={handleSubmit}>
        <div>
          <label>Username:</label>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Email:</label>
          <input
            value={email}
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Password:</label>
          <input
            value={password}
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Ruolo:</label>
          <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="admin">Admin</option>
            <option value="chef">Chef</option>
            <option value="waiter">Waiter</option>
            {/* Se vuoi permettere di creare pure super_admin... */}
            {/* <option value="super_admin">Super Admin</option> */}
          </select>
        </div>
        <button type="submit">Crea Utente</button>
      </form>
    </div>
  );
}

export default AddUserForm;
